import { Component } from '@angular/core';

@Component({
    selector: 'vb-about-page',
    templateUrl: './about-page.component.html',
    styleUrls: ['./about-page.component.scss'],
})
export class AboutPageComponent {
    public isLoading: boolean = true;
}
